import { render, staticRenderFns } from "./ProductTabsIndex.vue?vue&type=template&id=17d07f6e&scoped=true&"
import script from "./ProductTabsIndex.vue?vue&type=script&lang=js&"
export * from "./ProductTabsIndex.vue?vue&type=script&lang=js&"
import style0 from "./ProductTabsIndex.vue?vue&type=style&index=0&id=17d07f6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d07f6e",
  null
  
)

export default component.exports